import DynamicFormAndPDFViewer from 'components/form_pdfjs_component'
import React, { Fragment, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentStatus } from '../../slices/globalSlice'
import Download from 'components/QuestionnaireRequestAutomated/processor/components/Download'
import useFullscreen from 'components/QuestionnaireRequestAutomated/hooks/useFullscreen'
import FullscreenViewerHeader from '../FullscreenViewerHeader'
import UploadedIcon from '/app/assets/images/icons/file-no-form-uploaded.svg'

function Header({ formTitle }) {
  return (
    <>
      <div className="dome-h4 dome-color-lite-grey dome-text-w500">{formTitle}</div>
    </>
  )
}

const EmptyFormUploadViewer = () => {
  return (
    <div className="processing-page-form-content">
      <div style={{ height: '687px' }} className="dome-full-height dome-d-flex dome-flex-column dome-gap18">
        <div className="dome-h4 dome-color-lite-grey dome-text-w500">no form attached</div>
        <div
          className="dome-full-height dome-d-flex dome-justify-center"
          style={{ background: '#F9F9F9', borderRadius: 6, border: '1px solid var(--accent, #F0F0F0)' }}
        >
          <div style={{ marginTop: 153 }} className="dome-d-flex dome-flex-column dome-align-center dome-gap12">
            <img src={UploadedIcon} alt="no form uploaded" width={64} height={64} />
            <span className="dome-p1 dome-color-med-grey">no form uploaded</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function ManualQuestionnaireProcessorPreviewer(props) {
  const { formTitle } = props
  const respondingFiles = useSelector((state) => state.global.respondingFiles)
  const blankFormUrl = useSelector((state) => state.global.questionnaireForm.url)
  const blankFormPages = useSelector((state) => state.global.questionnaireForm.pages)
  const hashedId = useSelector((state) => state.global.hashedId)
  const currentStatus = useSelector(selectCurrentStatus)

  const { elementRef: pdfViewerRef, isFullscreen, triggerFullscreen, exitFullscreen } = useFullscreen()

  const document = useMemo(() => {
    if (respondingFiles.length === 0) {
      return blankFormUrl
        ? [
            {
              type: 'pdf',
              url: blankFormUrl,
              id: 'pdf-blank',
            },
          ]
        : blankFormPages.length > 0
          ? [
              {
                type: 'images',
                urls: blankFormPages,
                id: 'pdf-images',
              },
            ]
          : []
    }

    return respondingFiles.map((file) => ({
      type: 'pdf',
      url: file.url,
      id: `pdf-${file.id}`,
    }))
  }, [blankFormUrl, respondingFiles])

  const renderBtnText = useCallback(() => {
    switch (currentStatus) {
      case 'intake':
        return <></>
      case 'email sent':
      case 'archived':
      case 'canceled':
        return <Download questionnaireHashedId={hashedId} />
      default:
        return <></>
    }
  }, [currentStatus])

  if (document.length === 0) return <EmptyFormUploadViewer />

  return (
    <div className="processing-page-form-content">
      <div className="dome-d-flex dome-flex-column dome-gap18">
        <div className="dome-d-flex dome-justify-between">
          <Header formTitle={formTitle} />
          <div className="dome-d-flex dome-gap12">
            {renderBtnText()}
            <span className="dome-cursor-pointer" onClick={triggerFullscreen}>
              <i className="fa-solid fa-arrow-up-right-and-arrow-down-left-from-center dome-color-dark-grey"></i>
            </span>
          </div>
        </div>
        <div ref={pdfViewerRef} className="processing-page-pdf-form dome-d-flex dome-flex-column dome-align-end ">
          {isFullscreen && <FullscreenViewerHeader title={formTitle} onclose={exitFullscreen} />}
          <div className="dome-full-width dome-full-height processing-page-pdf-form-content">
            <DynamicFormAndPDFViewer document={document} />
          </div>
        </div>
      </div>
    </div>
  )
}
